import { Directive, OnChanges, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { NgControl, FormControl } from '@angular/forms';

@Directive({
  selector: '[appCheck]'
})
export class CheckDirective implements OnChanges {


  @Input('appCheck')

  check: boolean;
  input: NgControl;
  constructor(private ngControl: NgControl, private changeDetectorRef: ChangeDetectorRef) {

  }




  ngOnChanges(changes: SimpleChanges): void {
    if (changes.check.currentValue) {
      // TODO: Estudar o angular Life Cycle e remover esse setTimeout
      // Atualmente estamos usando pois essa diretiva entra em conflito com a [appUncheck]
      setTimeout(() => {
        (this.ngControl.control as FormControl).setValue(true);
      }, 0);

    }
  }

}
